import { render, staticRenderFns } from "./centurion-entertainment.vue?vue&type=template&id=29f1a970&scoped=true&"
import script from "./centurion-entertainment.vue?vue&type=script&lang=js&"
export * from "./centurion-entertainment.vue?vue&type=script&lang=js&"
import style0 from "./centurion-entertainment.vue?vue&type=style&index=0&id=29f1a970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f1a970",
  null
  
)

export default component.exports